"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
var JobRequisitionPostedDateGetter = (function () {
    function JobRequisitionPostedDateGetter() {
    }
    JobRequisitionPostedDateGetter.prototype.getJobRequisitionPostedDate = function (result, isCareerSiteDisplayPostingEndDateEnabled) {
        if (isCareerSiteDisplayPostingEndDateEnabled) {
            return csod.locales.get("ATS.SocialSharing.RequisitionPostedDateLabel", "Posted on: {0} - Application Deadline: {1}", result.postingEffectiveDate, result.postingExpirationDate);
        }
        else {
            return result.postingEffectiveDate;
        }
    };
    JobRequisitionPostedDateGetter.prototype.getJobRequisitionPostedDateLabelForJobDetailsPage = function (startDate, endDate, isPostingDateInJobDetailsPageEnabled, isCareerSiteDisplayPostingEndDateEnabled) {
        if (isPostingDateInJobDetailsPageEnabled) {
            if (isCareerSiteDisplayPostingEndDateEnabled) {
                return csod.locales.get("ATS.SocialSharing.RequisitionPostedDateLabel", "Posted on: {0} - Application Deadline: {1}", startDate, endDate);
            }
            else {
                return csod.locales.get("ATS.SocialSharing.RequisitionDatePostedLabel", "Posted on: {0}", startDate);
            }
        }
        else {
            return "";
        }
    };
    return JobRequisitionPostedDateGetter;
}());
exports.JobRequisitionPostedDateGetter = JobRequisitionPostedDateGetter;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/shared/JobRequisitionPostedDateGetter.ts
// module id = 171
// module chunks = 0